import React, { Fragment } from "react";

import Modal from "../generics/Modal";
import QRScanner from "../generics/QRScanner";
import SearchSelect from "../generics/SearchSelect";

const ChangeItemSubstituteModal = ({
  setIsChangeSubstituteItemModalOpen,
  isChangeSubstituteItemModalOpen,
  submitButcherItemChange,
  itemToSubstitute,
  maximumQtyToSubstitute,
  handleButcherItemChange,
  searchButcherItems,
  itemsList,
  selectedButcherItem,
  selectedButcherInventoryId,
  handleSelectedButcherInventoryIdChange,
  showQRScannerModal,
  openQRScannerModal,
  closeQRScannerModal,
  handleScannedInventory,
  handleScanError,
  scanResult,
  scanStatus,
  selectedButcherItemQty,
  handleButcherItemQtyChange,
  errorSubstituteQty,
  selectedButcherItemGrade,
  handleButcherItemGradeChange,
  gradesList,
  errorSubstituteGrade,
}) => {
  const itemToSubstituteGrade = itemToSubstitute.grade ? `(Grade: ${itemToSubstitute.grade}) ` : "";
  return (
    <Fragment>
      <Modal
        closeModal={setIsChangeSubstituteItemModalOpen}
        isModalOpen={isChangeSubstituteItemModalOpen}
        onConfirm={submitButcherItemChange}
        onCancel={setIsChangeSubstituteItemModalOpen}
        header="Change item to substitute"
        onConfirmButtonText="Continue"
        onCancelButtonText="Cancel"
        zIndex={3}
        autoFocus={false}
      >
        <div>
          <h6>Item to substitute:</h6>
          <input
            value={`${itemToSubstitute.name} ${itemToSubstituteGrade}- Qty: ${maximumQtyToSubstitute}`}
            className="form-control form-group"
            disabled
          />
          <h6>Please choose an item to substitute the current item:</h6>
          <SearchSelect
            onChange={handleButcherItemChange}
            getOptions={searchButcherItems}
            isLoading={itemsList.loading}
            value={selectedButcherItem.item_info}
            class="form-group row"
          />
          {selectedButcherItem.item_allows_grade_order && (
            <div className={`${errorSubstituteGrade && "has-danger"}`}>
              <select
                className="form-group form-control"
                id="select"
                name="select"
                value={selectedButcherItemGrade.grade_index}
                onChange={handleButcherItemGradeChange}
              >
                <option value="-1">Select grade</option>
                {gradesList && gradesList.grades && gradesList.grades.results ? (
                  gradesList.grades.results.map((elem, index) => {
                    return (
                      <option value={index} key={index}>
                        {elem.grade}
                      </option>
                    );
                  })
                ) : (
                  <option value=" ">Loading...</option>
                )}
              </select>
            </div>
          )}
          <input
            placeholder="Select inventory"
            value={selectedButcherInventoryId}
            onChange={handleSelectedButcherInventoryIdChange}
            className="form-control form-group"
            autoFocus
          />
          <span className="btn btn-primary scan-shipment-item form-group" onClick={openQRScannerModal}>
            <i className="fa fa-qrcode mr-05"></i>
            <span>Scan</span>
          </span>
          <h6>Please choose item qty to be substituted:</h6>
          <div className={`${errorSubstituteQty && "has-danger"}`}>
            <input
              type="number"
              className="form-control"
              placeholder="Choose a qty"
              value={selectedButcherItemQty}
              onChange={handleButcherItemQtyChange}
            />
          </div>
        </div>
      </Modal>
      <QRScanner
        show={showQRScannerModal}
        onHide={closeQRScannerModal}
        onScan={handleScannedInventory}
        onError={handleScanError}
        scanResult={scanResult}
        scanStatus={scanStatus}
      />
    </Fragment>
  );
};

export default ChangeItemSubstituteModal;
